import React from 'react';
import { Col, Card } from 'react-bootstrap';

interface PropsType {
  image: string;
  alt?: string;
}

const DashboardBanner: React.FC<PropsType> = ({ image, alt }) => (
  <Col md={12} className='pr-2 pt-2'>
    <Card className='card-banner d-none d-sm-block'>
      <Card.Img variant='top' src={image} alt={alt} />
    </Card>
  </Col>
);

export default DashboardBanner;
